import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../pages/HomeView.vue';
import Result from '../pages/result/Result.vue';
import Report from '../pages/Report.vue';
import Detail from '../pages/details/Detail.vue';
import Summary from '../pages/details/Summary.vue';
import Description from '../pages/details/Description.vue';
import Claim from '../pages/details/Claim.vue';
import Image from '../pages/details/Image.vue';
import { loadI18n } from '@/infrastructure/locales';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomeView,
            redirect: 'result',
            beforeEnter: async(to, from, next) => {
                await loadI18n();
                next();
            },
            children: [
                {
                    path: 'result',
                    name: 'result',
                    component: Result,
                },
                {
                    path: 'report',
                    name: 'report',
                    component: Report,
                },
                {
                    path: 'detail/:id',
                    name: 'detail',
                    component: Detail,
                    children: [
                        {
                            path: 'summary',
                            name: 'detailSummary',
                            component: Summary,
                        }, {
                            path: 'description',
                            name: 'detailDescription',
                            component: Description,
                        }, {
                            path: 'claim',
                            name: 'detailClaim',
                            component: Claim,
                        }, {
                            path: 'image',
                            name: 'detailImage',
                            component: Image,
                        }
                    ],
                }
            ],
        }
    ],
})

export default router
